import React, { useState } from "react";
import styled from "styled-components";
import AnimateHeight from "react-animate-height";
import ReactHtmlParser from "react-html-parser";
import IcomoonReact from "icomoon-react";
import iconSet from "../../fonts/selection.json";

const ButtonEl = styled.p`
  position: relative;
  width: 100%;
  padding: 14px 45px 14px 10px;
  margin: 0 0 1px 0;
  background-color: ${(props) =>
    props.color === "white" ? "#fff" : "#f5f5f5"};
  color: ${(props) => (props.color === "white" ? "#000" : "#707070")};
  font-size: 16px;
  line-height: 20px;
  font-weight: 900;
  cursor: pointer;
`;

const CollapseBox = styled.div`
  padding: 20px 10px;
  background-color: #fff;
`;

/**
 * ArticleTeaser component
 * @function ArticleTeaser
 * @param {Object} props
 * @param {String} props.color - props - "default" | "white"
 *
 */
const Collapse = ({ title, body, children, color }) => {
  const [height, setHeight] = useState(0);

  return (
    <>
      <ButtonEl
        color={color || "default"}
        onClick={() => setHeight(height === 0 ? "auto" : 0)}
      >
        {title}
        <IcomoonReact
          iconSet={iconSet}
          color={"#000"}
          icon={"right-arrow"}
          size={22}
          style={{
            position: "absolute",
            top: 14,
            right: 10,
            transform: height === 0 ? "rotate(90deg)" : "rotate(-90deg)",
          }}
        />
      </ButtonEl>
      <AnimateHeight duration={500} height={height}>
        {body ? (
          <CollapseBox className="wysiwyg">{ReactHtmlParser(body)}</CollapseBox>
        ) : (
          <CollapseBox>{children}</CollapseBox>
        )}
      </AnimateHeight>
    </>
  );
};

export default Collapse;
